// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__v-auJ","placeHolderShimmer":"ReportFilter_placeHolderShimmer__OauUE"};